"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _constants = require("composer-plugins/lib/constants");

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UITether = _interopRequireDefault(require("UITether/UITether"));

var _default = _react.default.createClass({
  displayName: "ImageComponent",
  propTypes: {
    block: _react.PropTypes.object.isRequired,
    blockProps: _react.PropTypes.object.isRequired,
    contentState: _react.PropTypes.object.isRequired
  },
  contextTypes: {
    getEditorState: _react.PropTypes.func.isRequired,
    getReadOnly: _react.PropTypes.func.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      selected: false
    };
  },
  componentDidMount: function componentDidMount() {
    var onInsertableLoaded = this.props.blockProps.onInsertableLoaded;
    document.body.addEventListener('click', this.onBodyClicked);
    _reactDom.default.findDOMNode(this._container).onload = onInsertableLoaded;
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var getCommentsOnly = nextProps.blockProps.getCommentsOnly;
    var getReadOnly = this.context.getReadOnly;
    return !getReadOnly() && !getCommentsOnly() && nextState.selected !== this.state.selected;
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.selected) {
      this.forceSelectionOfImageBlock();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClicked);
  },
  onBodyClicked: function onBodyClicked(e) {
    var imageEl = _reactDom.default.findDOMNode(this._container);

    if (imageEl && (e.target === imageEl || imageEl.contains(e.target))) {
      this.toggleSelected();
    } else if (this.state.selected) {
      this.setState({
        selected: false
      });
    }
  },
  forceSelectionOfImageBlock: function forceSelectionOfImageBlock() {
    var key = this.props.block.key;
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;
    window.getSelection().removeAllRanges();

    var selectionState = _draftJs.SelectionState.createEmpty(key).merge({
      anchorOffset: 1,
      focusOffset: 1
    });

    onChange(_draftJs.EditorState.forceSelection(getEditorState(), selectionState));
  },
  toggleSelected: function toggleSelected() {
    this.setState(function (prevState) {
      return {
        selected: !prevState.selected
      };
    });
  },
  onCloseClick: function onCloseClick() {
    var key = this.props.block.key;
    var _this$context2 = this.context,
        getEditorState = _this$context2.getEditorState,
        onChange = _this$context2.onChange;
    var editorState = getEditorState();
    var rawContent = editorState.getCurrentContent().getBlockMap();

    var contentWithoutImage = _draftJs.ContentState.createFromBlockArray(rawContent.remove(key).toArray());

    onChange(_draftJs.EditorState.push(editorState, contentWithoutImage, 'remove-range'));
  },
  renderCloseButton: function renderCloseButton() {
    if (!this.state.selected) {
      return _react.default.createElement("div", null);
    }

    return _react.default.createElement(_UICloseButton.default, {
      onClick: this.onCloseClick
    });
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState;
    var selected = this.state.selected;
    var key = block.getEntityAt(0);

    if (!key) {
      return null;
    }

    var _contentState$getEnti = contentState.getEntity(key).getData(),
        name = _contentState$getEnti.name,
        src = _contentState$getEnti.src;

    var classNames = (0, _classNames.default)(_constants.IMAGE_COMPONENT_CLASSNAME, {
      selected: selected
    });
    return _react.default.createElement(_UITether.default, {
      classPrefix: "compose-draft-image-close-button",
      attachmentHoriz: "left",
      attachmentVert: "top",
      targetAttachmentHoriz: "right",
      targetAttachmentVert: "top",
      content: this.renderCloseButton,
      constraints: [{
        to: 'scrollParent',
        pin: ['right']
      }]
    }, _react.default.createElement(_UIImage.default, {
      alt: name,
      className: classNames,
      ref: function ref(c) {
        return _this._container = c;
      },
      responsive: false,
      src: src
    }));
  }
});

exports.default = _default;
module.exports = exports.default;